import React, { Component } from 'react';
import TableCell from './TableCell';

export default class TableBody extends Component {

    onCellInput(value) {
        value.id = this.props.onCellInput(value);
    }

    render() {
        let that = this;
        return (
            <tbody>
                {this.props.data ? Object.keys(this.props.data).map(function(id, i) {

                    let isLastRow   = i === Object.keys(that.props.data).length - 1;

                    let cells = that.props.rows.map(function(row, j){

                        row             = row.toLowerCase();
                        let isLastTitle = row === 'title' && isLastRow;
                        let shouldFocus = isLastTitle && !that.props.data[id][row];

                        return <TableCell key={j} onInput={that.onCellInput.bind(that)} type={row} value={that.props.data[id][row]} rowId={id} hasAutoFocus={shouldFocus} />;
                    });

                    return <tr key={i} id={id}>{cells}</tr>;
                }) : null}
            </tbody>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/TableBody.js